import moment from "moment"
import React from "react"
import { Badge, Card, Col, ListGroup, Row, Table } from "react-bootstrap"

export default function ObservationSatuSehat({
    getObservation,
}) {
    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    💓 Observation
                </Card.Header>
                <Card.Body className="p-0" style={{ height: '180px', overflowY: 'auto', overflowX: 'auto' }}>
                    <div style={{ minWidth: '600px' }}>
                        <Table
                            bordered
                            striped
                            responsive
                            size="sm"
                            className="mb-0 small"
                            style={{ minWidth: '750px' }}
                        >
                            <thead className="table-light text-center">
                                <tr>
                                    <th>#</th>
                                    <th>📋 Jenis</th>
                                    <th>📍 Lokasi</th>
                                    <th>💉 Nilai</th>
                                    <th>📌 Status</th>
                                    <th>⏰ Waktu</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getObservation?.entry?.length > 0 ? (
                                    getObservation.entry.map((item, idx) => {
                                        const obs = item.resource;
                                        return (
                                            <tr key={idx}>
                                                <td className="text-center">{idx + 1}</td>
                                                <td>{obs.code?.coding?.[0]?.display || '-'}</td>
                                                <td>{obs.bodySite?.coding?.[0]?.display || '-'}</td>
                                                <td>
                                                    {obs.valueQuantity?.value || '-'} {obs.valueQuantity?.unit || ''}
                                                </td>
                                                <td className="text-center">
                                                    <Badge bg="info" className="text-uppercase small">
                                                        {obs.status || '-'}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    {obs.effectiveDateTime
                                                        ? moment(obs.effectiveDateTime).format('DD MMM YYYY, HH:mm')
                                                        : '-'}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            Tidak ada data tanda vital
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}